import { Dispatch, SetStateAction } from 'react';

import { useTheme } from 'styled-components';

import Typography from '@components/Typography';
import { DateType } from '@utils/dateUtil';
import { CheckAvailabilityViewModel } from '@api/index';
import { DateRangePicker } from '@components/DatePicker';
import { ProfileReservation, CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Tooltip from '@components/ui/Tooltip/next';

import {
  getOneMonthDatesRange,
  renderEventsAndAvailableDates,
} from './helpers';
import {
  Container,
  Wrapper,
  DatePickerWrapper,
  DatePickerHeader,
  CloseIconWrapper,
  SearchButton,
  SearchButtonWrapper,
} from './styled';
import DateStatusTypes from './DateStatusTypes';

interface Props {
  setVisibleAvailableDates: Dispatch<SetStateAction<boolean | undefined>>;
  visibleAvailableDates: boolean;
  data?: CheckAvailabilityViewModel;
  isFetching: boolean;
  events: { items: any[] };
  setStartDate: Dispatch<SetStateAction<DateType | null>>;
  setEndDate: Dispatch<SetStateAction<DateType | null>>;
  startDate: DateType | null;
  endDate: DateType | null;
  handleSearch: () => void;
}

const DesktopAvailableRoomDates = ({
  setVisibleAvailableDates,
  visibleAvailableDates,
  data,
  events,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSearch,
}: Props) => {
  const { palette } = useTheme();

  const setDates = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  return (
    <Container>
      <Tooltip
        borderRadius='8px'
        trigger='click'
        placement='bottomRight'
        onOpenChange={(visible) => setVisibleAvailableDates(visible)}
        open={visibleAvailableDates}
        getPopupContainer={(trigger) => trigger}
        zIndex={10}
        title={
          <DatePickerWrapper>
            <DatePickerHeader>
              <DateStatusTypes />
              <CloseIconWrapper>
                <CustomIcon
                  icon={CloseIcon}
                  fontSize={24}
                  paletteColor='darkGrey'
                  clickable
                  onClick={() => setVisibleAvailableDates(false)}
                />
              </CloseIconWrapper>
            </DatePickerHeader>
            <DateRangePicker
              startDate={startDate}
              endDate={endDate}
              onDatesChange={setDates}
              renderDayContents={(day) =>
                renderEventsAndAvailableDates(day, palette, events, data)
              }
              isHoliday={false}
              isOutsideRange={(day) =>
                getOneMonthDatesRange(day, startDate, endDate)
              }
            />
            <SearchButtonWrapper>
              <SearchButton
                disabled={!startDate || !endDate}
                onClick={handleSearch}
              >
                Ara
              </SearchButton>
            </SearchButtonWrapper>
          </DatePickerWrapper>
        }
      >
        <Wrapper>
          <Typography variant='caption2' color='NL0' weight='SemiBold'>
            Müsaitlik Takvimi
          </Typography>

          <CustomIcon
            icon={ProfileReservation}
            fontSize={18}
            paletteColor='white'
          />
        </Wrapper>
      </Tooltip>
    </Container>
  );
};

export default DesktopAvailableRoomDates;
